import { NetworkIcon } from 'elements/NetworkIcon';
import { NETWORK_IDS } from 'lib/constants';
import { omitBy } from 'lodash';
import { SignInOptions } from './types';

interface Props {
  returnTo?: string;
  errorTo?: string;
  text?: string;
}

/**
 * Use this whenever you need a direct link to TikTok for signin. This handles app-specific
 * logic, requesting a specific username, and specifying a return-to path.
 */
export const onClickTikTokSignin = (options: SignInOptions) => {
  const baseUrl = '/api/auth/tiktok';

  // if app is used divert request and return out of normal redirect flow
  // if (isGondolaApp && isGondolaAppVersionAtLeast('1.0.8')) {
  //   sendAuthRequestToApp('tiktok', baseUrl);
  //   return;
  // }

  const allParams = {
    next: options.returnTo || '/',
    username: options.username,
    errorTo: options.errorTo,
  };
  const params = omitBy(allParams, (v) => !v) as Record<string, string>;
  const authUrl = `${baseUrl}?${new URLSearchParams(params).toString()}`;

  window.location.href = authUrl;
};

export const TikTokSignIn = ({ returnTo, text, errorTo }: Props) => {
  const onClick = () => onClickTikTokSignin({
    returnTo,
    errorTo,
  });

  return (
    <button
      type="button"
      className="rounded-lg bg-black hover:bg-opacity-90 font-bold text-white text-xl w-full max-w-xs py-2"
      onClick={onClick}
    >
      <NetworkIcon
        style={{
          color: 'white',
          marginRight: '8px',
          verticalAlign: 'middle',
        }}
        network={NETWORK_IDS.tiktok}
        iconColor="#ffffff"
      />
      {text || 'Sign in with TikTok'}
    </button>
  );
};
